import type { LogoDePrixia } from './elegir-logo';
import { MISIONES } from '../misiones';
import { N, RANK } from './rombo';

/* Lo que el logo muestra según las misiones hechas. Sin `three`: lo usa el SVG de la tarjeta. */
export const MISIONES_DEL_LOGO = MISIONES.length;
const MISIONES_POR_PLACA = 2;

/** Los lugares vacíos se ven en contorno, con esta opacidad (`putGhost` del prototipo). */
export const OPACIDAD_DEL_CONTORNO = 0.55;

const POR_ANILLO = Math.ceil(N / MISIONES_DEL_LOGO);
/** En qué anillo está cada punto: del centro hacia afuera, uno por misión. */
export const ANILLO_DE_MISION = RANK.map((lugar) =>
  Math.min(MISIONES_DEL_LOGO - 1, Math.floor(lugar / POR_ANILLO))
);

/** Lo que tarda en encajar una pieza. */
export const ENCAJE_MS = 900;
const PAUSA_MS = 700;
/** La sexta: el giro arranca con `ENCAJE_MS`, y el texto aparece antes de que termine. */
export const GIRO_FINAL_MS = 1300;
export const TEXTO_FINAL_MS = 2000;
const CIERRE_FINAL_MS = 3700;

export function piezasDelLogo(hechas: number) {
  const n = Math.max(0, Math.min(MISIONES_DEL_LOGO, hechas));
  return {
    placas: Math.floor(n / MISIONES_POR_PLACA),
    anillos: n,
    completo: n === MISIONES_DEL_LOGO,
  };
}

export interface PiezaQueEntra {
  tipo: 'placa' | 'anillo';
  indice: number;
}

/** La pieza de la misión número `enTotal`; `null` si esa misión no agrega ninguna. */
export function piezaQueEntra(logo: LogoDePrixia, enTotal: number): PiezaQueEntra | null {
  if (enTotal < 1 || enTotal > MISIONES_DEL_LOGO) return null;
  if (logo === 'nuevo') return { tipo: 'anillo', indice: enTotal - 1 };
  if (enTotal % MISIONES_POR_PLACA !== 0) return null;
  return { tipo: 'placa', indice: enTotal / MISIONES_POR_PLACA - 1 };
}

export const duracionDelPanel = (enTotal: number) =>
  enTotal === MISIONES_DEL_LOGO ? CIERRE_FINAL_MS : ENCAJE_MS + PAUSA_MS;
